
<template>
	<div>
		<div class="px-7 pt-3" style="height:100%; overflow-y:scoll">
			<router-view></router-view>
		</div>
		<!-- full screen page loader -->
		<page-loader/>
	</div>
</template>	

<script type="text/javascript">


export default {
	components: {
		PageLoader: () => import('@/components/common-components/PageLoader.vue'),
	},
}
</script>